import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/** A typed day-first date: 05/11/2026, 5/11/26, 05-11-2026, 05.11.2026. */
const DAY_FIRST_DATE = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2}|\d{4})$/;

/**
 * Native date adapter that reads typed dates day first when the date locale is French.
 * The native adapter hands them to Date.parse(), which reads them month first: "05/11/2026"
 * became 11 May while the calendar and the display are in French. Display, calendar and
 * any other input (ISO strings, other locales) are left to NativeDateAdapter.
 */
@Injectable()
export class LivecoDateAdapter extends NativeDateAdapter {
    override parse(value: any, parseFormat?: any): Date | null {
        if (typeof value === 'string' && this.isFrench()) {
            const match = DAY_FIRST_DATE.exec(value.trim());
            if (match) {
                const day = Number(match[1]);
                const month = Number(match[2]);
                let year = Number(match[3]);
                if (match[3].length === 2) {
                    // Same rule as Date.parse() for two-digit years: 00-49 -> 20xx, 50-99 -> 19xx
                    year += year < 50 ? 2000 : 1900;
                }
                if (month < 1 || month > 12 || day < 1 || day > this.getNumDaysInMonth(this.createDate(year, month - 1, 1))) {
                    return this.invalid();
                }
                return this.createDate(year, month - 1, day);
            }
        }
        return super.parse(value, parseFormat);
    }

    private isFrench(): boolean {
        return String(this.locale ?? '').toLowerCase().startsWith('fr');
    }
}
